<template>
  <div class="row">
    <div class="header-lixi">
      <img
        src="../../assets/images/background-header.png"
        alt="">
      <div class="tab-content-lixi">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#tang_lixi">Tặng lì xì</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#nhan_lixi">Nhận lì xì</a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#da_tang">Đã tặng</a>
          </li>
        </ul>
        <div class="tab-content">
          <div
            id="tang_lixi"
            class="tab-pane container active">
            <router-link to="/">
              <div class="session-tang-lixi">
                <div class="session-img">
                  <img
                    src="../../assets/images/icon_lixi_1.png"
                    alt="">
                </div>
                <div class="session-content">
                  <p class="text-uppercase">lá số tử vi và vận hạn</p>
                  <span>Xem chi tiết</span>
                </div>
                <div class="session-icon">
                  <i class="fa fa-chevron-right"/>
                </div>
              </div>
            </router-link>
            <router-link to="/">
              <div class="session-tang-lixi">
                <div class="session-img">
                  <img
                    src="../../assets/images/icon_lixi_2.png"
                    alt="">
                </div>
                <div class="session-content">
                  <p class="text-uppercase">tặng tài khoản vip</p>
                  <router-link to="/"><span>Xem chi tiết</span></router-link>
                </div>
                <div class="session-icon">
                  <i class="fa fa-chevron-right"/>
                </div>
              </div>
            </router-link>
            <router-link to="/">
              <div class="session-tang-lixi">
                <div class="session-img">
                  <img
                    src="../../assets/images/icon_lixi_3.png"
                    alt="">
                </div>
                <div class="session-content">
                  <p class="text-uppercase">khoá học phong thuỷ trực tuyến</p>
                  <router-link to="/"><span>Xem chi tiết</span></router-link>
                </div>
                <div class="session-icon">
                  <i class="fa fa-chevron-right"/>
                </div>
              </div>
            </router-link>
          </div>
          <div
            id="nhan_lixi"
            class="tab-pane container fade">
            <!--<div class="row">
              <div class="session-nhan-lixi">
                <div class="session-avatar">
                  <img
                    src="../../assets/img/dummy/u1.png"
                    alt="">
                </div>
                <div class="session-descrip">
                  <p>Lorem ipsum dolor - Lorem ipsum dolor sit amet, consectetur</p>
                  <span>2020-02-02 19:30:12</span>
                </div>
                <div class="session-btn">
                  <router-link to="/"><span class="bg-red">Nhận</span></router-link>
                </div>
              </div>
            </div>-->

            <div class="row">
              <div class="session-nhan-lixi">
                <div class="session-avatar">
                  <img
                    src="../../assets/img/dummy/u1.png"
                    alt="">
                </div>
                <div class="session-descrip">
                  <p>Lorem ipsum dolor - Lorem ipsum dolor sit amet, consectetur</p>
                  <span>2020-02-02 19:30:12</span>
                </div>
                <div class="session-btn">
                  <router-link to="/"><span class="bg-success">Đã nhận</span></router-link>
                </div>
              </div>
            </div>
          </div>
          <div
            id="da_tang"
            class="tab-pane container fade">
            <div class="session-tang-lixi">
              <div class="session-img">
                <img
                  src="../../assets/images/icon_lixi_1.png"
                  alt="">
              </div>
              <div class="session-content">
                <p class="text-capitalize">Bạn đã tặng - 0867517812 - Giải lá số</p>
              </div>
              <div class="session-icon">
                <i class="fa fa-chevron-right"/>
              </div>
            </div>
            <div class="session-tang-lixi">
              <div class="session-img">
                <img
                  src="../../assets/images/icon_lixi_2.png"
                  alt="">
              </div>
              <div class="session-content">
                <p class="text-capitalize">Bạn đã tặng - 0867517812 - Gói cước tháng</p>
              </div>
              <div class="session-icon">
                <i class="fa fa-chevron-right"/>
              </div>
            </div>
            <div class="session-tang-lixi">
              <div class="session-img">
                <img
                  src="../../assets/images/icon_lixi_3.png"
                  alt="">
              </div>
              <div class="session-content">
                <p class="text-capitalize">Bạn đã tặng - 0867517812 - Khoá học cho người tuổi tuất</p>
              </div>
              <div class="session-icon">
                <i class="fa fa-chevron-right"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'Index'
  }
</script>

<style scoped>
    .header-lixi {
        width: 100%;
        height: auto;
        position: relative;
    }
    .header-lixi img {
        width: 100%;
        height: 150px;
        max-height: 150px;
        clear: both;
    }
    .header-lixi .tab-content-lixi {
        position: relative;
        bottom: 45px;
        clear: both;
    }
    .header-lixi .nav-tabs {
        width: 100%;
    }
    .header-lixi .nav-tabs .nav-item {
        width: 33.33%;
    }
    .header-lixi .nav-tabs .nav-item .nav-link {
        padding: 10px 12px;
        text-align: center;
        font-size: 0.9rem;
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
    }
    .header-lixi .nav-tabs .nav-item .active {
        color: #EA2F2F !important;
        background-color: #fff;
    }

    .header-lixi .tab-content {
        background-color: #E5E5E5;
        max-height: 300px;
        height: 280px;
        background-image: url('../../assets/images/background_1.png'), url('../../assets/images/background2.png'), url('../../assets/images/background_3.png');
        background-position:left top, left bottom, right bottom;
        background-repeat: no-repeat;
        overflow: scroll;
    }
    .tab-content .session-tang-lixi {
        width: 100%;
        height: auto;
        max-height: 85px;
        display: flex;
        padding: 5px 0;
        background: #fff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        margin-top: 5px;
    }
    .tab-content .session-tang-lixi .session-img {
        flex-basis: 12%;
        /*background: linear-gradient(179.22deg, #F88383 -18.89%, #FE5050 105%);*/
        border-radius: 0 22px 22px 0;
    }
    .tab-content .session-tang-lixi .session-img img {
      width: 100%;
      height: 45px;
      max-height: 45px;
      padding: 3px 0px;
    }
    .tab-content .session-tang-lixi .session-content {
        flex-basis: 85%;
        margin-left: 5px;
    }
    .session-content p {
        margin-bottom: 0;
        font-style: normal;
        font-weight: bold;
        font-size: 0.8rem;
        line-height: 16px;
        color: #5E6372;
        padding-top: 6px;
    }
    .session-content span {
        font-style: normal;
        font-weight: 600;
        font-size: 0.7rem;
        line-height: 18px;
        align-items: center;
        color: #11CA71;
    }
    .session-icon .fa-chevron-right {
        color: #5E6372;
        position: relative;
        top: 30%;
        right: 5px;
        font-size: 0.8rem;

    }
    .tab-content .session-tang-lixi .session-icon {
        flex-basis: 3%;
    }
    .tab-content .session-nhan-lixi {
      width: 100%;
      height: auto;
      max-height: 95px;
      display: flex;
      background: rgba(196, 196, 196, 0.3);
      margin-top: 3px;
    }
    .tab-content .session-nhan-lixi .session-avatar {
      flex-basis: 10%;
    }
    .tab-content .session-nhan-lixi .session-avatar img {
      display: block;
      margin-left: auto;
      margin-right: auto;
      width: 65px;
      height: 65px;
      border-radius: 50%;
      padding: 10px;
    }
    .tab-content .session-nhan-lixi .session-descrip {
      flex-basis: 65%;
      margin-right: 5px;
    }
    .tab-content .session-nhan-lixi .session-descrip p {
      font-size: 0.8rem;
      margin-bottom: 0;
      padding-top: 10px;
      font-weight: bold;
    }
    .tab-content .session-nhan-lixi .session-btn {
      flex-basis: 20%;
      position: relative;
      margin-right: 5px;
    }
    .tab-content .session-nhan-lixi .session-btn span {
        margin: 0;
        position: absolute;
        top: 30%;
        width: 100%;
        text-align: center;
        padding: 5px;
        color: #fff;
        font-weight: bold;
        border-radius: 4px;
    }
</style>



// WEBPACK FOOTER //
// src/components/lixi/Index.vue